import { Camera, Snowflake, Wheat } from "lucide-react";
import { montarBonus, type BonusMd } from "@/lib/bonusesMd";
import firstLoafMd from "./content/first-loaf.md?raw";
import bakeOnceMd from "./content/bake-once-toast-all-week.md?raw";
import flourDecoderMd from "./content/flour-decoder.md?raw";

/**
 * Os três bônus que a oferta do Clean Bakes no funil do Clean Cakes promete
 * (UP3 do CESC, 25/09/2026, na voz da Nora): The First Loaf, Bake Once Toast
 * All Week e The Flour Decoder. Como os outros bônus do app, não são produto
 * da Hotmart e não têm gate próprio.
 *
 * Quem vê: quem tem o Clean Bakes E o Clean Cakes — é nesse funil que eles
 * foram prometidos, e a prosa fala com quem já tem os bolos ("your Sweetener
 * Decoder"). Quem comprou o Clean Bakes por outro funil (Clean Sweets,
 * Clean Mornings) não os vê; ver `bonusesDeQuemTem` em src/lib/bonusModules.ts.
 *
 * O maquinário é o compartilhado (src/lib/bonusesMd.ts) — a extração que o
 * Clean Meals deixou combinada para o terceiro módulo.
 */
export type CleanBakesBonus = BonusMd;

export const CLEAN_BAKES_PREFIX = "/clean-bakes";

export const CLEAN_BAKES_BONUSES: CleanBakesBonus[] = [
  montarBonus(
    "first-loaf",
    "The First Loaf",
    "The Sunday Loaf, photographed at every step",
    Camera,
    firstLoafMd,
  ),
  montarBonus(
    "bake-once-toast-all-week",
    "Bake Once, Toast All Week",
    "The whole week of bread from one Sunday",
    Snowflake,
    bakeOnceMd,
  ),
  montarBonus(
    "flour-decoder",
    "The Flour Decoder",
    "Which flour holds which job in a loaf",
    Wheat,
    flourDecoderMd,
  ),
];

export const bonusesRoute = `${CLEAN_BAKES_PREFIX}/bonuses`;
export const bonusRoute = (slug: string) => `${bonusesRoute}/${slug}`;
export const findBonus = (slug?: string) =>
  CLEAN_BAKES_BONUSES.find((b) => b.slug === slug) ?? null;
